/**
 * Полоса недели: выбор дня одним тапом.
 *
 * Родитель планирует неделями, а смотрит днями, поэтому неделя — это
 * навигация, а не отдельный экран со своей вёрсткой.
 */

import clsx from 'clsx'

import { WEEKDAY_LABELS, type ScheduleTask } from '@/shared/api/schedule'
import { haptic } from '@/shared/telegram'

export function WeekStrip({
  start,
  selected,
  tasks,
  onSelect,
}: {
  start: string
  selected: string
  tasks: ScheduleTask[]
  onSelect: (date: string) => void
}) {
  const days = Array.from({ length: 7 }, (_, index) => {
    const date = new Date(`${start}T12:00:00Z`)
    date.setUTCDate(date.getUTCDate() + index)
    return date.toISOString().slice(0, 10)
  })

  const countByDay = new Map<string, number>()
  for (const task of tasks) {
    if (task.status === 'planned') {
      countByDay.set(task.date, (countByDay.get(task.date) ?? 0) + 1)
    }
  }

  const today = new Date().toISOString().slice(0, 10)

  // На 320px семь колонок по 44px в отступы экрана не помещаются, поэтому
  // полоса слегка выходит за них: иначе ячейка дня становится слишком узкой.
  // -mx-4 съедает горизонтальные поля экрана: без этого семь дней по 44px
  // в 320px не помещаются, а тач-таргет уменьшать нельзя.
  return (
    <div className="-mx-4 grid grid-cols-7">
      {days.map((day, index) => {
        const active = day === selected
        const count = countByDay.get(day) ?? 0
        return (
          <button
            key={day}
            type="button"
            onClick={() => {
              haptic('select')
              onSelect(day)
            }}
            className={clsx(
              'press flex flex-col items-center gap-0.5 rounded-[var(--radius-tile)] py-2',
              active ? 'bg-accent text-on-accent' : 'bg-surface',
              !active && day === today && 'ring-accent/40 ring-1',
            )}
          >
            <span
              className={clsx(
                'text-micro',
                active ? 'text-on-accent/85' : 'text-text-muted',
              )}
            >
              {WEEKDAY_LABELS[index]}
            </span>
            <span className="tabular text-body font-semibold">
              {Number(day.slice(8, 10))}
            </span>
            <span
              className={clsx(
                'size-1.5 rounded-full',
                count > 0 ? (active ? 'bg-white' : 'bg-accent') : 'bg-transparent',
              )}
            />
          </button>
        )
      })}
    </div>
  )
}
